export const configRegistry: Record<string, () => Promise<any>> = {
    Cars: () => import('@/components/listing/cars/cars.config'),
    Clients: () => import('@/components/modules/clients/clients.config'),
    Quotations: () => import('@/components/modules/quotations/quotations.config'),
    Sales: () => import('@/components/modules/sales/sales.config'),
    Opportunities: () => import('@/components/modules/opportunities/opportunities.config'),
    Activities: () => import('@/components/modules/activities/activities.config'),
    Expenses: () => import('@/components/modules/expenses/expenses.config'),
    Collections: () => import('@/components/modules/collections/collections.config'),
    Influencers: () => import('@/components/modules/influencers/influencers.config'),
    Products: () => import ('@/components/listing/products/products.config'),
    Posters: () => import ('@/components/listing/posters/posters.config'),
    Leads: () => import ('@/components/modules/leads/leads.config'),
    Contacts: () => import ('@/components/modules/clients/contacts/contacts.config'),
    Users: () => import ('@/components/modules/users/users.config')
};
  
